const settings = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000/graphql/',
  wsUrl: process.env.REACT_APP_API_WS_URL || 'ws://localhost:8000/graphql/',
  querySize: 100,
};

export default settings;
